import React, { FunctionComponent, useEffect, useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';

import { useRequiredValidation } from '../../../../../utils/form/validation.utils';
import { FormSmallTextInput } from '../../inputs/SmallTextInput';

import { ITeamFileAddFolderFormProps } from './types';
import { ICreateMeetingFolder } from '../../../../../app/resource/meeting-shortcuts/meeting-shortcuts.types';
import { IMeetingSimple } from '../../../../../app/resource/meeting-simple/meeting-simple.types';
import { useParams } from 'react-router-dom';
import { meetingShortcutsCreateFolderlMeetingDashboardPage } from '../../../../../app/page/meeting-dashboard/meeting-dashboard.actions';
import { useSelectWithParams } from '../../../../../utils/selector.utils';
import { meetingFilesSelectedSelectors } from '../../../../../app/resource/meeting-shortcuts/meeting-shortcuts.selectors';
import { apiSelectors } from '../../../../../app/api/api.selectors';

export const MeetingShortcutAddFolderForm: FunctionComponent<ITeamFileAddFolderFormProps> = () => {
  const { meetingId } = useParams<{ meetingId: IMeetingSimple['id'] }>();
  const [createFolderErrorMessage, setCreateFolderErrorMessage] = useState('');

  const [meetingShortcutsSelected] = useSelectWithParams(meetingFilesSelectedSelectors.selectResourceList, meetingId);
  const parentId = !meetingShortcutsSelected?.parentId ? meetingShortcutsSelected?.id : undefined;
  const createFolderError = useSelectWithParams(apiSelectors.selectApiError, 'createFileFolder');

  useEffect(() => {
    if (createFolderError) {
      if (createFolderError.statusCode === 409) {
        setCreateFolderErrorMessage('The name already exists in the current directory');
      } else {
        setCreateFolderErrorMessage('There was a problem creating the folder.');
      }
    }
  }, [createFolderError]);

  const dispatch = useDispatch();

  const formProps = useForm();

  const requiredValidation = useRequiredValidation();

  const onSubmit = ({ name }: ICreateMeetingFolder) => {
    dispatch(meetingShortcutsCreateFolderlMeetingDashboardPage(meetingId, name, parentId));
  };

  return (
    <FormProvider {...formProps}>
      <form
        id="team-files-create-folder-form"
        className="topic-form"
        onSubmit={formProps.handleSubmit((formData) => onSubmit((formData as unknown) as ICreateMeetingFolder))}
        method="post"
      >
        <div className="field-container">
          <FormSmallTextInput
            id="name"
            name="name"
            type="text"
            label="Folder name"
            placeholder="Paste folder name here..."
            validation={requiredValidation}
          />
        </div>
        {createFolderError && <label style={{ color: 'red' }}>{createFolderErrorMessage}</label>}
      </form>
    </FormProvider>
  );
};
